import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IncidentDownloadService {
  apiName = 'Default';
  

  downloadFileByIncidentId = (incidentId: string) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/app/tenant-incidents/download',
      params: { incidentId },
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
